export const printTicket = (clear) => {
    let mywindow = window.open('', 'IMPRIMIR TICKET', "fullscreen=yes");
    let content = (document.getElementsByClassName('print-container')[0]) ? (document.getElementsByClassName('print-hidden-container')[0]).innerHTML : '';

    var htmlToPrint = '' +
        '<style type="text/css">' +
        'table {' +
        'border-spacing:6px;' +
        '}' +
        'table th{' +
        'border-bottom:2px solid #000;' +
        '}' +
        '</style>';

    htmlToPrint += content;

    mywindow.document.write('<html>');
    mywindow.document.write('<body >');
    mywindow.document.write(htmlToPrint);
    mywindow.document.write('</body></html>');

    setTimeout(function() {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        if(!!clear) clear();
        mywindow.close();
    }, 250);
}


// WEBPACK FOOTER //
// ./src/helpers/utils.js